
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/pilebyg",
      function () {
        return require("private-next-pages/archive/pilebyg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/pilebyg"])
      });
    }
  